import React, { useState, lazy } from 'react';
import PageHeader from '../components/layout/PageHeader';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
import Alert from '../components/ui/Alert';
const Contact = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    // Simulate form submission
    setTimeout(() => {
      // 90% chance of success for demo purposes
      if (Math.random() > 0.1) {
        setFormStatus('success');
      } else {
        setFormStatus('error');
      }
    }, 1500);
  };
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    setFormStatus('idle');
  };
  return <div className="min-h-screen bg-white" data-id="element-4183">
      <PageHeader title="Contact Us" description="Get in touch with Isonyin Grammar School. We're here to answer your questions and provide the information you need." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Contact Us',
      path: '/contact'
    }]} data-id="element-4184" />
      <div className="container mx-auto px-4 py-12" data-id="element-4185">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10" data-id="element-4186">
          {/* Contact Information */}
          <div className="lg:col-span-1" data-id="element-4187">
            <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-4188">
              Contact Information
            </h2>
            <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-4189">
              <div className="flex items-start mb-6" data-id="element-4190">
                <div className="bg-blue-900 p-3 rounded-full text-white mr-4" data-id="element-4191">
                  <MapPinIcon className="h-6 w-6" data-id="element-4192" />
                </div>
                <div data-id="element-4193">
                  <h3 className="font-bold text-blue-900 mb-1" data-id="element-4194">
                    School Address
                  </h3>
                  <p className="text-gray-700" data-id="element-4195">
                    Isonyin Grammar School
                    <br data-id="element-4196" />
                    123 Education Road
                    <br data-id="element-4197" />
                    Isonyin, Ijebu North East
                    <br data-id="element-4198" />
                    Ogun State, Nigeria
                  </p>
                  <a href="#" className="text-blue-700 hover:text-blue-900 mt-2 inline-flex items-center text-sm" data-id="element-4199">
                    View on Google Maps
                    <ExternalLinkIcon className="h-4 w-4 ml-1" data-id="element-4200" />
                  </a>
                </div>
              </div>
              <div className="flex items-start mb-6" data-id="element-4201">
                <div className="bg-blue-900 p-3 rounded-full text-white mr-4" data-id="element-4202">
                  <PhoneIcon className="h-6 w-6" data-id="element-4203" />
                </div>
                <div data-id="element-4204">
                  <h3 className="font-bold text-blue-900 mb-1" data-id="element-4205">
                    Phone Numbers
                  </h3>
                  <p className="text-gray-700 mb-1" data-id="element-4206">
                    Main Office:{' '}
                    <a href="tel:+2349055172703" className="text-blue-700 hover:text-blue-900" data-id="element-4207">
                      +234 905 517 2703
                    </a>
                  </p>
                  <p className="text-gray-700 mb-1" data-id="element-4208">
                    Admissions:{' '}
                    <a href="tel:+2349055172703" className="text-blue-700 hover:text-blue-900" data-id="element-4209">
                      +234 905 517 2703
                    </a>
                  </p>
                  <p className="text-gray-700" data-id="element-4210">
                    Principal's Office:{' '}
                    <a href="tel:+2349055172703" className="text-blue-700 hover:text-blue-900" data-id="element-4211">
                      +234 905 517 2703
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-start mb-6" data-id="element-4212">
                <div className="bg-blue-900 p-3 rounded-full text-white mr-4" data-id="element-4213">
                  <MailIcon className="h-6 w-6" data-id="element-4214" />
                </div>
                <div data-id="element-4215">
                  <h3 className="font-bold text-blue-900 mb-1" data-id="element-4216">
                    Email Addresses
                  </h3>
                  <p className="text-gray-700 mb-1" data-id="element-4217">
                    General Inquiries:{' '}
                    <a href="mailto:info@isonyingrammarschool.ng" className="text-blue-700 hover:text-blue-900" data-id="element-4218">
                      info@isonyingrammarschool.ng
                    </a>
                  </p>
                  <p className="text-gray-700 mb-1" data-id="element-4219">
                    Admissions:{' '}
                    <a href="mailto:admissions@isonyingrammarschool.ng" className="text-blue-700 hover:text-blue-900" data-id="element-4220">
                      admissions@isonyingrammarschool.ng
                    </a>
                  </p>
                  <p className="text-gray-700" data-id="element-4221">
                    Principal's Office:{' '}
                    <a href="mailto:principal@isonyingrammarschool.ng" className="text-blue-700 hover:text-blue-900" data-id="element-4222">
                      principal@isonyingrammarschool.ng
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-4223">
                <div className="bg-blue-900 p-3 rounded-full text-white mr-4" data-id="element-4224">
                  <ClockIcon className="h-6 w-6" data-id="element-4225" />
                </div>
                <div data-id="element-4226">
                  <h3 className="font-bold text-blue-900 mb-1" data-id="element-4227">Office Hours</h3>
                  <p className="text-gray-700 mb-1" data-id="element-4228">
                    Monday - Friday: 8:00 AM - 4:00 PM
                  </p>
                  <p className="text-gray-700 mb-1" data-id="element-4229">
                    Saturday: 9:00 AM - 12:00 PM (Admissions only)
                  </p>
                  <p className="text-gray-700" data-id="element-4230">Sunday: Closed</p>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4231">
              <h3 className="font-bold text-blue-900 mb-4" data-id="element-4232">Follow Us</h3>
              <div className="flex space-x-4" data-id="element-4233">
                <a href="#" className="bg-blue-900 text-white p-3 rounded-full hover:bg-blue-700 transition-colors" data-id="element-4234">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-4235">
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" data-id="element-4236" />
                  </svg>
                </a>
                <a href="#" className="bg-blue-900 text-white p-3 rounded-full hover:bg-blue-700 transition-colors" data-id="element-4237">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-4238">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" data-id="element-4239" />
                  </svg>
                </a>
                <a href="#" className="bg-blue-900 text-white p-3 rounded-full hover:bg-blue-700 transition-colors" data-id="element-4240">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-4241">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-4242" />
                  </svg>
                </a>
                <a href="#" className="bg-blue-900 text-white p-3 rounded-full hover:bg-blue-700 transition-colors" data-id="element-4243">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-4244">
                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" data-id="element-4245" />
                  </svg>
                </a>
                <a href="#" className="bg-blue-900 text-white p-3 rounded-full hover:bg-blue-700 transition-colors" data-id="element-4246">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-4247">
                    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" data-id="element-4248" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-4249">
            <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-4250">
              Send Us a Message
            </h2>
            {formStatus === 'success' && <Alert variant="success" title="Message Sent Successfully!" className="mb-6" data-id="element-4251">
                Thank you for contacting Isonyin Grammar School. We have
                received your message and will respond shortly.
              </Alert>}
            {formStatus === 'error' && <Alert variant="error" title="Error Sending Message" className="mb-6" dismissible data-id="element-4252">
                There was a problem sending your message. Please try again or
                contact us directly via phone.
              </Alert>}
            <form onSubmit={handleSubmit} className={formStatus === 'success' ? 'hidden' : 'bg-white p-6 rounded-lg shadow-md'} data-id="element-4253">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-4254">
                <div data-id="element-4255">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4256">
                    Your Name <span className="text-red-500" data-id="element-4257">*</span>
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-4258" />
                </div>
                <div data-id="element-4259">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4260">
                    Email Address <span className="text-red-500" data-id="element-4261">*</span>
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-4262" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-4263">
                <div data-id="element-4264">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4265">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-4266" />
                </div>
                <div data-id="element-4267">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4268">
                    Subject <span className="text-red-500" data-id="element-4269">*</span>
                  </label>
                  <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-4270">
                    <option value="" data-id="element-4271">Select a subject</option>
                    <option value="General Inquiry" data-id="element-4272">General Inquiry</option>
                    <option value="Admissions" data-id="element-4273">Admissions</option>
                    <option value="Academic Programs" data-id="element-4274">Academic Programs</option>
                    <option value="Boarding Facilities" data-id="element-4275">
                      Boarding Facilities
                    </option>
                    <option value="Scholarships" data-id="element-4276">Scholarships</option>
                    <option value="Employment" data-id="element-4277">Employment Opportunities</option>
                    <option value="Alumni" data-id="element-4278">Alumni Relations</option>
                    <option value="Other" data-id="element-4279">Other</option>
                  </select>
                </div>
              </div>
              <div className="mb-6" data-id="element-4280">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4281">
                  Your Message <span className="text-red-500" data-id="element-4282">*</span>
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Please provide details about your inquiry..." data-id="element-4283"></textarea>
              </div>
              <div className="flex items-start mb-6" data-id="element-4284">
                <div className="flex items-center h-5" data-id="element-4285">
                  <input id="privacy" name="privacy" type="checkbox" required className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" data-id="element-4286" />
                </div>
                <div className="ml-3 text-sm" data-id="element-4287">
                  <label htmlFor="privacy" className="font-medium text-gray-700" data-id="element-4288">
                    I agree to the{' '}
                    <a href="/privacy-policy" className="text-blue-600 hover:underline" data-id="element-4289">
                      privacy policy
                    </a>{' '}
                    and consent to being contacted regarding my inquiry{' '}
                    <span className="text-red-500" data-id="element-4290">*</span>
                  </label>
                </div>
              </div>
              <div className="flex justify-between" data-id="element-4291">
                <button type="submit" disabled={formStatus === 'submitting'} className={`px-6 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${formStatus === 'submitting' ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-4292">
                  {formStatus === 'submitting' ? <span className="flex items-center" data-id="element-4293">
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-4294">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-4295"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-4296"></path>
                      </svg>
                      Sending...
                    </span> : 'Send Message'}
                </button>
                <button type="button" onClick={() => resetForm()} className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-4297">
                  Reset Form
                </button>
              </div>
            </form>
            {formStatus === 'success' && <div className="text-center mt-4" data-id="element-4298">
                <button onClick={() => resetForm()} className="px-6 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-4299">
                  Send Another Message
                </button>
              </div>}
            {/* Map */}
            <div className="mt-10" data-id="element-4300">
              <h2 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-4301">
                Our Location
              </h2>
              <div className="rounded-lg overflow-hidden shadow-md h-[400px] bg-gray-200 flex items-center justify-center" data-id="element-4302">
                <div className="text-center p-4" data-id="element-4303">
                  <MapPinIcon className="h-12 w-12 text-blue-900 mx-auto mb-2" data-id="element-4304" />
                  <h3 className="font-bold text-lg mb-1" data-id="element-4305">School Location</h3>
                  <p className="text-gray-700" data-id="element-4306">
                    Isonyin Grammar School, Ijebu North East, Ogun State,
                    Nigeria
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="mt-16" data-id="element-4307">
          <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-4308">
            Frequently Asked Questions
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-4309">
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-4310">
              <div className="divide-y divide-gray-200" data-id="element-4311">
                <div className="p-6" data-id="element-4312">
                  <h3 className="font-bold text-lg text-blue-900 mb-2" data-id="element-4313">
                    What are the school's office hours?
                  </h3>
                  <p className="text-gray-700" data-id="element-4314">
                    Our administrative office is open Monday through Friday from
                    8:00 AM to 4:00 PM. The admissions office is also open on
                    Saturdays from 9:00 AM to 12:00 PM. All offices are closed
                    on Sundays and public holidays.
                  </p>
                </div>
                <div className="p-6" data-id="element-4315">
                  <h3 className="font-bold text-lg text-blue-900 mb-2" data-id="element-4316">
                    How can I schedule a school tour?
                  </h3>
                  <p className="text-gray-700" data-id="element-4317">
                    School tours are available by appointment. Please contact
                    our admissions office at
                    admissions@isonyingrammarschool.edu.ng or call +234 (0) 803
                    234 5678 to schedule a tour. We recommend booking at least
                    one week in advance.
                  </p>
                </div>
                <div className="p-6" data-id="element-4318">
                  <h3 className="font-bold text-lg text-blue-900 mb-2" data-id="element-4319">
                    What is the best way to contact a specific teacher?
                  </h3>
                  <p className="text-gray-700" data-id="element-4320">
                    The best way to contact a teacher is through our school
                    email system. Each teacher has an email address in the
                    format firstname.lastname@isonyingrammarschool.edu.ng. You
                    can also leave a message with our front office, and the
                    teacher will get back to you.
                  </p>
                </div>
                <div className="p-6" data-id="element-4321">
                  <h3 className="font-bold text-lg text-blue-900 mb-2" data-id="element-4322">
                    How do I apply for admission to Isonyin Grammar School?
                  </h3>
                  <p className="text-gray-700" data-id="element-4323">
                    You can apply for admission through our online application
                    portal on the Admissions page of our website. Alternatively,
                    you can visit our admissions office to pick up a physical
                    application form. For more details on the admission process,
                    please visit our{' '}
                    <a href="/admissions" className="text-blue-700 hover:text-blue-900" data-id="element-4324">
                      Admissions page
                    </a>
                    .
                  </p>
                </div>
                <div className="p-6" data-id="element-4325">
                  <h3 className="font-bold text-lg text-blue-900 mb-2" data-id="element-4326">
                    How can I join the Parent-Teacher Association (PTA)?
                  </h3>
                  <p className="text-gray-700" data-id="element-4327">
                    All parents of current students are automatically members of
                    the PTA. To get involved in PTA activities and committees,
                    please contact the PTA secretary at
                    pta@isonyingrammarschool.edu.ng or attend the next PTA
                    meeting. Meeting schedules are posted on our{' '}
                    <a href="/pta" className="text-blue-700 hover:text-blue-900" data-id="element-4328">
                      PTA page
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;